import React from 'react';
import Header from '../../components/Header';
import { EventsTrigger } from 'src/components/EventsTrigger/EventsTrigger';
import CustomersBar from '../../components/CustomersBar';
import Audits from '../../components/Audits';
import DashboardGrid from '../../components/DashboardGrid';
import {Events} from 'src/domains/sportsbook/trading/view/eventDetails/Events.tsx';
import { ComplianceAudits } from 'src/components/ComplianceAudits/ComplianceAudits';
import { PepXmlRouterWrapper} from 'src/components/FraudAndCompliance/PEPTab/PEP/PepXml/PepXml';
import { AuditIdMission } from 'src/components/AuditIdMission/AuditIdMission';

class DashboardPage extends React.Component {
    render() {
        return (
            <div>
                <Header />
                <DashboardGrid />
                <CustomersBar />
                <EventsTrigger />

                <Events />

                <Audits />
                <ComplianceAudits />
                <AuditIdMission />
                <PepXmlRouterWrapper/>
            </div>
        );
    }
}

export default DashboardPage;
